import { render } from "./typograPhy.vue?vue&type=template&id=3649e818"
import script from "./typograPhy.vue?vue&type=script&lang=js"
export * from "./typograPhy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__